import { Button, Checkbox, Dropdown, Icon, Pagination, Table } from "semantic-ui-react"
import ScrollableTable from "components/TableWrapper";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useState } from "react";

export default function ListTable(props: any): JSX.Element {
  const { hotel } = props
  const [state, setState] = useState<any>({
    column: null,
    direction: null,
  });
  const [loading, setLoading,] = useState<boolean>(false)
  const [clickedRow, setClickedRow,] = useState<any>(null)

  const {
    pagination,
    setPagination,
    confirmations,
    bookings,
    setBookings,
    popup,
    setPopup,
    editRecord,
    setEditRecord,
    sendConfirmationNotification,
    filter,
    setFilter,
    fetchCount,
    setFetchCount,
    bookingFilter,
    queryString,
    setNewConfirmation,
  } = props

  const hotelName = props.hotel?.getHotelName()
  const data = props.isBooking ? bookings : confirmations

  const handleSort = (sortInfo: any) => {
    const { sort, column, value, direction } = sortInfo;
    if (!sort) return;

    const { type } = sort;
    // console.log(column, value, type, data);

    if (column === value) {
      const tmp = data;
      data.splice(0, data.length, ...tmp.slice().reverse());

      setState({
        ...state,
        direction: direction === "ascending" ? "descending" : "ascending",
      });
      return;
    }

    const sortedData = data.sort((a: any, b: any) => {
      if (!b[sort.key || value] || !a[sort.key || value]) return;
      if (type === "number") return b[sort.key || value] - a[sort.key || value];
      if (type === "string") return b[sort.key || value].localeCompare(a[sort.key || value]);
      if (type === "date") return new Date(b[value]).getTime() - new Date(a[value]).getTime();
    });
    data.splice(0, data.length, ...sortedData);
    setState({ ...state, column: value, direction: "ascending" });
  };

  const tableHeader = {
    parklane:6,
    mini:5,
  }

  return (
    <ScrollableTable>
      <Table.Header>
        <Table.Row textAlign='center' >
          <Table.HeaderCell
            sorted={state.column === "confirmationNumber" ? state.direction : null}
              onClick={()=>setPagination((prev:any)=>({...prev,sortBy:pagination.sortBy==="sendAt"?"sendAt.asc":"sendAt"}))}
            width="1">
            Confirmation No.
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "lastName" ? state.direction : null}
            onClick={()=>setPagination((prev:any)=>({...prev,sortBy:pagination.sortBy==="bookingNumber"?"bookingNumber.asc":"bookingNumber"}))}
          >
            Name
          </Table.HeaderCell>
          <Table.HeaderCell
            width="2"
            sorted={state.column === "checkInDate" ? state.direction : null}
            onClick={()=>setPagination((prev:any)=>({...prev,sortBy:pagination.sortBy==="checkInDate"?"checkInDate.asc":"checkInDate"}))}
          >
            Check In / Out time
          </Table.HeaderCell>
          <Table.HeaderCell
            width="1"
            sorted={state.column === "email" ? state.direction : null}
            onClick={()=>setPagination((prev:any)=>({...prev,sortBy:pagination.sortBy==="email"?"email.asc":"email"}))}
          >
            Email
          </Table.HeaderCell>
          {hotelName?.toLowerCase()?.includes('parklane') ?
            <Table.HeaderCell
              width="2"
              sorted={state.column === "phone" ? state.direction : null}
              onClick={()=>setPagination((prev:any)=>({...prev,sortBy:pagination.sortBy==="phone"?"phone.asc":"phone"}))}
            >
              Phone
            </Table.HeaderCell> :
            <></>}
          <Table.HeaderCell width="2">
            <div>Actions</div>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {data.length === 0 ? <>no records</> : data
          .filter((item: any) => {
            const { filtering } = filter

            if (Object.values(queryString).some(value => value)) {
              return !!Object.keys(item).find(key => {
                // console.log(typeof item?.[key], item[key])

                const found = typeof item?.[key] === "string" &&
                  item?.[key]?.toLowerCase().includes(queryString?.["any"]?.toLowerCase())

                const byCheckInDate = dayjs(queryString["checkInDate"]).isValid() &&
                  dayjs(item["checkInDate"]).isAfter(dayjs(queryString["checkInDate"]).subtract(1, "days"))

                return !dayjs(queryString["checkInDate"]).isValid() ? found : found && byCheckInDate
              })
            }

            // if (props.isBooking) {
            //   return !confirmations
            //     .find(({ bookingNumber }: any) => bookingNumber === item.confirmationNumber)
            // }

            return item
          })
          .map((item: any, i: number) => {
            const fullName = `${item?.profile?.lastName || ''} ${item?.profile?.firstName || ''}`
            const checkInTime = dayjs(item?.checkInDate || '').isValid() ? dayjs(item.checkInDate).format("YYYY-MM-DD HH:mm:ss") : ""
            const checkOutTime = dayjs(item?.checkOutDate || '').isValid() ? dayjs(item.checkOutDate).format("YYYY-MM-DD HH:mm:ss") : ""
            const confirmationNumber = item.bookingNumber || item.confirmationNumber

            return (
              <Table.Row textAlign='center' key={i}>
                <Table.Cell >{confirmationNumber}</Table.Cell>
                <Table.Cell ><div className="w-max">{fullName}</div></Table.Cell>
                <Table.Cell width={10} style={{ width: "10rem" }}>
                  <div className="w-max">
                    <div className="flex justify-between"><div className="mr-2">IN:</div><div>{checkInTime}</div></div>
                    <hr />
                    <div className="flex justify-between"><div className="mr-2">OUT:</div><div>{checkOutTime}</div></div>
                  </div>
                </Table.Cell>
                <Table.Cell ><div className="flex flex-wrap w-min">{
                  item?.email ||
                  item?.profile?.email?.email
                }</div></Table.Cell>
                {
                  hotelName?.toLowerCase()?.includes('parklane') ?
                    <Table.Cell ><div className="flex">{
                      editRecord?.phoneNumber ||
                      item?.phoneNumber ||
                      item?.profile?.phoneNumber?.number
                    }</div></Table.Cell> : <></>
                }
                <Table.Cell>
                  <div className="flex justify-center gap-1">
                    <Icon
                      style={{ margin: "auto 0" }}
                      className="w-min cursor-pointer"
                      color="yellow"
                      name="edit"
                      onClick={() => {
                        setNewConfirmation({ email: item?.profile?.email?.email, phoneNumber: item?.profile?.phoneNumber?.number })
                        setEditRecord(item)
                        setPopup({ ...popup, edit: true })
                      }}
                    />
                    <Button
                      className="w-min"
                      size="tiny"
                      color={!item?.sendAt || !item?.profile?.email?.email ? 'yellow' : undefined}
                      content={!item?.sendAt || !item?.profile?.email?.email ?
                        `Send` :
                        `Sent at ${dayjs(item?.sendAt).format("YYYY-MM-DD HH:mm:ss")}`}
                      icon="paper plane"
                      labelPosition="left"
                      style={{ marginTop: ".5rem", padding: '.3rem' }}
                      disabled={loading && item.bookingNumber===clickedRow}
                      loading={loading && item.bookingNumber===clickedRow}
                      onClick={async () => {
                        try {
                          const email = editRecord?.email || item?.profile?.email?.email
                          const phoneNumber = editRecord?.phoneNumber || item?.profile?.phoneNumber?.number

                          if (!item.email && !item?.profile?.email?.email) {
                            return toast.error(`Email is missing, failed to send notification`)
                          }

                          // console.log({item})
                          const sendNotiReqData = {
                            // ...item,
                            // email: item.email || item.profile?.email?.email,
                            email,
                            phoneNumber,
                            bookingNumber: item.confirmationNumber,
                            arrivalDate: dayjs(item.checkInDate).format("YYYY-MM-DD"),
                            sentAt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
                            thirdPartyNumber: item.encryptedConfirmationNumber || item.thirdPartyNumber||"missing",
                            firstName:item?.profile?.firstName,
                            lastName:item?.profile?.lastName,
                          }
                          if (!hotelName?.toLowerCase()?.includes('parklane'))
                            delete sendNotiReqData.phoneNumber

                          setLoading((loading: boolean) => true)
                          setClickedRow((row: any) => item.bookingNumber)
                          await sendConfirmationNotification(sendNotiReqData)
                          setLoading((loading: boolean) => false)
                          setClickedRow((row: any) => null)

                          toast.success(
                            <div style={{ textAlign: 'left' }}>
                              <div> {`email sent to: ${email}`} </div>
                              {
                                hotelName?.toLowerCase()?.includes('parklane') ?
                                  <div> {`whatsapp sent to: ${phoneNumber}`} </div> : <></>
                              }
                            </div>
                          )

                          if (props.isBooking) {
                            const index = bookings.findIndex((booking: any) => booking.confirmationNumber === item.confirmationNumber)
                            if (index > -1)
                              bookings.splice(index, 1)
                            setBookings([...bookings])
                          }

                          // setFetchCount(fetchCount + 1)
                        } catch (err:any) {
                          console.log('send err:',err.message)
                          setLoading((loading: boolean) => false)
                          toast.error(
                            <div style={{ textAlign: 'left' }}>
                              <div> {`Failed to send...`} </div>
                              <div> {`message: ${err.message}`} </div>
                            </div>
                          )
                        }
                      }}
                    />
                    {
                      !props.isBooking &&
                      <Icon
                        style={{ margin: "auto 0" }}
                        className="w-min cursor-pointer"
                        disabled={item.isBooking}
                        color="red"
                        name="trash alternate"
                        onClick={() => {
                          setEditRecord(item)
                          setPopup({ ...popup, delete: true })
                        }}
                      />
                    }
                  </div>
                </Table.Cell>
              </Table.Row>
            )
          })}
      </Table.Body>
      <Table.Footer>
        {
        !props.isBooking?
          <Table.Row textAlign="center">
            <Table.HeaderCell colSpan={tableHeader[hotelName?.toLowerCase()?.includes("parklane") ?"parklane" : "mini"]}>
              <Pagination
                defaultActivePage={pagination.page || 1}
                totalPages={pagination.totalPages || 1}
                firstItem={null}
                lastItem={null}
                onPageChange={(_, { activePage }) => {
                  // console.log({ activePage })
                  setPagination((prev: any) => ({ ...prev, page: activePage }))
                }}
                />
              <Dropdown
                selection
                style={{marginLeft:".5rem",height:"3rem"}}
                compact
                value={pagination.itemsPerPage}
                options={[
                  {
                    key: "25",
                    value: 25,
                    text: "25",
                  },
                  {
                    key: "50",
                    value: 50,
                    text: "50",
                  },
                  {
                    key: "100",
                    value: 100,
                    text: "100",
                  },
                ]}
                onChange={(_,{value})=>{
                  setPagination((prev:any)=>({...prev,itemsPerPage:value}))
                }}
                />
            </Table.HeaderCell>
          </Table.Row> :<></>
        }
      </Table.Footer>
    </ScrollableTable>

  )
}
